export default __webpack_public_path__ + "static/media/home_blue_icon.ab7e3ffa.svg";